import { render, staticRenderFns } from "./SaleBtn.vue?vue&type=template&id=0ca2f9d3&"
import script from "./SaleBtn.vue?vue&type=script&lang=js&"
export * from "./SaleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports